import React from 'react';

/**
 * Clean, high-precision SVG vector icons for Halloween Theme
 * Based on open-source vector icon geometry (OpenSVG / SVGRepo style)
 */

export const HalloweenPumpkinIcon = ({ className = 'w-5 h-5', style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <defs>
        <radialGradient id="pshJackOrange" cx="50%" cy="55%" r="48%">
          <stop offset="0%" stopColor="#fb923c" />
          <stop offset="70%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#c2410c" />
        </radialGradient>
        <radialGradient id="pshJackInnerGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="35%" stopColor="#fef08a" />
          <stop offset="100%" stopColor="#eab308" />
        </radialGradient>
      </defs>

      {/* Stem */}
      <path
        d="M15.5 6.5 C15.5 3 18.5 2 20 1 C18.2 3.2 17.2 4.2 17 6.5 Z"
        fill="#15803d"
        stroke="#166534"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      {/* Pumpkin Rib Lobes (Outer Back) */}
      <ellipse cx="16" cy="18" rx="13" ry="10.5" fill="url(#pshJackOrange)" stroke="#9a3412" strokeWidth="1" />
      <ellipse cx="10.5" cy="18" rx="7.5" ry="10" fill="url(#pshJackOrange)" stroke="#9a3412" strokeWidth="0.75" />
      <ellipse cx="21.5" cy="18" rx="7.5" ry="10" fill="url(#pshJackOrange)" stroke="#9a3412" strokeWidth="0.75" />
      <ellipse cx="16" cy="18" rx="5.5" ry="10.2" fill="url(#pshJackOrange)" stroke="#9a3412" strokeWidth="0.7" />

      {/* Carved Left Eye */}
      <polygon
        points="9.5,13.5 13.5,16.5 9,17.5"
        fill="url(#pshJackInnerGlow)"
        stroke="#78350f"
        strokeWidth="0.5"
      />
      {/* Carved Right Eye */}
      <polygon
        points="22.5,13.5 18.5,16.5 23,17.5"
        fill="url(#pshJackInnerGlow)"
        stroke="#78350f"
        strokeWidth="0.5"
      />
      {/* Carved Triangle Nose */}
      <polygon
        points="16,16 14.5,19 17.5,19"
        fill="url(#pshJackInnerGlow)"
        stroke="#78350f"
        strokeWidth="0.4"
      />
      {/* Carved Jagged Toothy Grin */}
      <path
        d="M8.5 21 L11.5 24 L13.5 22 L16 24.5 L18.5 22 L20.5 24 L23.5 21 L21 22.5 L18.5 20.8 L16 22.8 L13.5 20.8 L11 22.5 Z"
        fill="url(#pshJackInnerGlow)"
        stroke="#78350f"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HalloweenBatIcon = ({ className = 'w-5 h-5', style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Symmetrical Gothic Bat Silhouette */}
      <path
        d="M16 14.5 C13.5 9.5 7.5 7 1.5 11 C4.2 13.5 5.5 17 9.5 17 C11.5 17 13.2 15.8 14.5 17.2 C13.2 18.5 10.8 19.8 7 19.8 C10.5 22.5 14.2 20 16 18.8 C17.8 20 21.5 22.5 25 19.8 C21.2 19.8 18.8 18.5 17.5 17.2 C18.8 15.8 20.5 17 22.5 17 C26.5 17 27.8 13.5 30.5 11 C24.5 7 18.5 9.5 16 14.5 Z"
      />
      {/* Bat Head with Pointed Ears */}
      <path
        d="M14 14.5 L14.2 10.5 L15.2 12.5 L16.8 12.5 L17.8 10.5 L18 14.5 Z"
      />
      {/* Subtle Glowing Eyes */}
      <circle cx="15.2" cy="13.2" r="0.6" fill="#fb923c" />
      <circle cx="16.8" cy="13.2" r="0.6" fill="#fb923c" />
    </svg>
  );
};

export const HalloweenSpiderWebIcon = ({ className = 'w-5 h-5', style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Radial Spokes from top-left (0,0) */}
      <path d="M0 0 L32 0" strokeWidth="1" />
      <path d="M0 0 L0 32" strokeWidth="1" />
      <path d="M0 0 L32 32" strokeWidth="0.9" />
      <path d="M0 0 L32 16" strokeWidth="0.8" />
      <path d="M0 0 L16 32" strokeWidth="0.8" />
      <path d="M0 0 L32 8" strokeWidth="0.6" opacity="0.6" />
      <path d="M0 0 L8 32" strokeWidth="0.6" opacity="0.6" />

      {/* Concentric Spider Web Swags */}
      <path d="M8 0 Q 7.5 7.5 0 8" strokeWidth="0.9" />
      <path d="M16 0 Q 15 15 0 16" strokeWidth="0.9" />
      <path d="M24 0 Q 22.5 22.5 0 24" strokeWidth="0.9" />
      <path d="M32 0 Q 30 30 0 32" strokeWidth="1" />

      {/* Tiny dangling silhouetted spider on web strand */}
      <line x1="22" y1="22" x2="22" y2="28" strokeWidth="0.6" strokeDasharray="1 1" />
      <circle cx="22" cy="29" r="1.5" fill="currentColor" />
    </svg>
  );
};

export const HalloweenWitchHatIcon = ({ className = 'w-5 h-5', style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Pointed Gothic Cone */}
      <path
        d="M16 3 C13.5 8 8 20 5 23 L27 23 C24 20 18.5 8 16 3 Z"
        fill="#312e81"
        stroke="#1e1b4b"
        strokeWidth="1"
      />
      {/* Wide Curved Brim */}
      <ellipse cx="16" cy="23.5" rx="14" ry="4" fill="#1e1b4b" stroke="#0f172a" strokeWidth="1" />
      {/* Orange/Gold Ribbon Band */}
      <path
        d="M6.8 22 C12 24.2 20 24.2 25.2 22 L24.6 20 C19.6 22 12.4 22 7.4 20 Z"
        fill="#f97316"
      />
      {/* Gold Buckle */}
      <rect x="14" y="19.5" width="4" height="3.5" rx="0.5" fill="none" stroke="#fef08a" strokeWidth="1" />
    </svg>
  );
};

export const HalloweenGhostIcon = ({ className = 'w-5 h-5', style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Smooth Cute Ghost Body */}
      <path
        d="M16 3 C9.5 3 7 8 7 15 C7 20 5.5 25 8 28 C10 29.5 11.5 27 13.5 27 C15.5 27 16.5 29 18.5 29 C20.5 29 21.5 27 23.5 27 C25.5 27 27 29.5 29 27.5 C27.5 22 25 15 25 15 C25 8 22.5 3 16 3 Z"
        fill="#f8fafc"
        stroke="#cbd5e1"
        strokeWidth="0.8"
      />
      {/* Ghost Arms */}
      <path
        d="M7 16 C4.5 15.5 3 17 4 19 C5.5 20.5 7 18.5 7 18 Z"
        fill="#f8fafc"
      />
      <path
        d="M25 16 C27.5 15.5 29 17 28 19 C26.5 20.5 25 18.5 25 18 Z"
        fill="#f8fafc"
      />
      {/* Expressive Eyes & Smile */}
      <ellipse cx="13" cy="12" rx="1.6" ry="2.2" fill="#0f172a" />
      <ellipse cx="19" cy="12" rx="1.6" ry="2.2" fill="#0f172a" />
      <circle cx="12.4" cy="11.2" r="0.6" fill="#ffffff" />
      <circle cx="18.4" cy="11.2" r="0.6" fill="#ffffff" />
      <ellipse cx="16" cy="17" rx="1.8" ry="2.5" fill="#0f172a" />
      {/* Rosy Cheeks */}
      <ellipse cx="10.5" cy="14" rx="1.4" ry="0.8" fill="#f43f5e" opacity="0.4" />
      <ellipse cx="21.5" cy="14" rx="1.4" ry="0.8" fill="#f43f5e" opacity="0.4" />
    </svg>
  );
};

/**
 * Dedicated Corner Spider Web for Product Cards and Modals
 */
export const HalloweenCardCornerWeb = ({ className = 'w-9 h-9', position = 'top-right' }) => {
  const isRight = position === 'top-right';
  return (
    <div
      className={`absolute top-0 ${isRight ? 'right-0' : 'left-0'} pointer-events-none z-10 opacity-70 transition-opacity duration-300 group-hover:opacity-100 ${
        !isRight ? 'scale-x-[-1]' : ''
      }`}
    >
      <HalloweenSpiderWebIcon className={`${className} text-stone-400 drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)]`} />
    </div>
  );
};
